import { Controller } from "@hotwired/stimulus"
import { useTransition } from 'stimulus-use'

export default class extends Controller {
  static targets = ['wrapper', 'modal', 'backdrop']
  static values = {
    opened: Boolean
  }

  connect() {
    if (!this.backdropTarget.classList.contains('hidden') && !this.wrapperTarget.classList.contains('hidden') && !this.openedValue) {
      this.backdropTarget.classList.toggle('hidden')
      this.wrapperTarget.classList.toggle('hidden')
    }

    useTransition(this, {
      element: this.modalTarget
    })

    if (this.openedValue) {
      this.toggleTransition()
    }
  }

  toggle() {
    this.wrapperTarget.classList.toggle('hidden')
    this.backdropTarget.classList.toggle('hidden')
    this.toggleTransition()
  }

  close() {
    this.toggle()
  }
}
